module.exports = __webpack_public_path__ + "static/hero3-e4120d9ce540b8e502185f57fe2ad270.jpg";